const sizes = {
  'xs': {
    height: 19,
    width: 19,
  },
  'sm': {
    height: 33,
    width: 33,
  },
  'md': {
    height: 50,
    width: 50,
  },
  'lg': {
    height: 70,
    width: 70,
  },
  'xl': {
    height: 90,
    width: 90,
  },
  '2xl': {
    height: 100,
    width: 100,
  },
  '3xl': {
    height: 120,
    width: 120,
  },
  '4xl': {
    height: 140,
    width: 140,
  },
};

export default { sizes };
